import React, { Component } from "react";
import TextStyler from "../TextStyler/TextStyler";

class PayrollFooter extends Component {
  constructor(props) {
    super(props);
    const footer = props.footer || props;
    
    // Migrate from old format to new array-based format
    let sections = footer.sections;
    if (!sections) {
      // Create default sections or migrate from old format
      sections = [];
      const sectionLetters = ['A', 'B', 'C', 'D'];
      const defaultData = {
        A: {
          text: "CERTIFIED: Services duly rendered as stated.",
          name: "RHUBIE M. TAMAYO",
          position: "Acting Chief, Compensation & Employee Benefits Section",
        },
        B: {
          text: "CERTIFIED: Supporting documents complete and proper, and cash available in the amount of ₱ 0.00",
          name: "CHESTER KEVIN S. SY",
          position: "Chief, Accounting Section",
        },
        C: {
          text: "Approved for Payment",
          name: "MARY ANN O. CARANTO",
          position: "Chief Administrative Division",
        },
        D: {
          text: "CERTIFIED: Each employee whose name appears on the payroll has been paid the amount as indicated opposite his/her name.",
          name: "LILIBETH F. LINTAG",
          position: "Disbursing Officer",
        },
      };

      sectionLetters.forEach((letter, index) => {
        const visible = footer[`section${letter}_visible`] ?? (index < 2); // Default: show first 2
        if (visible) {
          sections.push({
            id: Date.now() + index,
            label: footer[`section${letter}_label`] ?? letter,
            text: footer[`section${letter}_text`] || defaultData[letter].text,
            name: footer[`section${letter}_name`] || defaultData[letter].name,
            position: footer[`section${letter}_position`] || defaultData[letter].position,
            textStyle: footer[`section${letter}_textStyle`] || { color: "#000000", fontSize: 12, bold: false, italic: false },
            nameStyle: footer[`section${letter}_nameStyle`] || { color: "#000000", fontSize: 14, bold: true, italic: false },
            positionStyle: footer[`section${letter}_positionStyle`] || { color: "#000000", fontSize: 12, bold: false, italic: false },
          });
        }
      });
    }

    this.state = {
      sections: sections.length > 0 ? sections : [
        {
          id: Date.now(),
          label: "A",
          text: "CERTIFIED: Services duly rendered as stated.",
          name: "RHUBIE M. TAMAYO",
          position: "Acting Chief, Compensation & Employee Benefits Section",
          textStyle: { color: "#000000", fontSize: 12, bold: false, italic: false },
          nameStyle: { color: "#000000", fontSize: 14, bold: true, italic: false },
          positionStyle: { color: "#000000", fontSize: 12, bold: false, italic: false },
        },
        {
          id: Date.now() + 1,
          label: "B",
          text: "CERTIFIED: Supporting documents complete and proper, and cash available in the amount of ₱ 0.00",
          name: "CHESTER KEVIN S. SY",
          position: "Chief, Accounting Section",
          textStyle: { color: "#000000", fontSize: 12, bold: false, italic: false },
          nameStyle: { color: "#000000", fontSize: 14, bold: true, italic: false },
          positionStyle: { color: "#000000", fontSize: 12, bold: false, italic: false },
        }
      ]
    };
    this.debounceTimer = null;
    this.nextSectionNumber = this.state.sections.length + 1;
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
      const footer = this.props.footer || this.props;
      if (footer.sections) {
        this.setState({ sections: footer.sections });
      }
    }
  }

  componentWillUnmount() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  }

  _notifyChange = () => {
    if (this.props.onChange) {
      this.props.onChange({ sections: this.state.sections });
    }
  };

  _handleSectionChange = (sectionId, field, value) => {
    const sections = this.state.sections.map(section =>
      section.id === sectionId ? { ...section, [field]: value } : section
    );

    this.setState({ sections }, () => {
      if (typeof value === "string") {
        // Debounce text inputs
        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
        }
        this.debounceTimer = setTimeout(() => {
          this._notifyChange();
        }, 300);
      } else {
        // Immediate update for style objects
        this._notifyChange();
      }
    });
  };

  _addSection = () => {
    const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    const newSection = {
      id: Date.now(),
      label: letters[this.state.sections.length % letters.length],
      text: "",
      name: "",
      position: "",
      textStyle: { color: "#000000", fontSize: 12, bold: false, italic: false },
      nameStyle: { color: "#000000", fontSize: 14, bold: true, italic: false },
      positionStyle: { color: "#000000", fontSize: 12, bold: false, italic: false },
    };

    this.setState(
      { sections: [...this.state.sections, newSection] },
      () => this._notifyChange()
    );
  };

  _removeSection = (sectionId) => {
    if (this.state.sections.length <= 1) {
      alert('You must have at least one section.');
      return;
    }

    const sections = this.state.sections.filter(section => section.id !== sectionId);
    this.setState({ sections }, () => this._notifyChange());
  };

  renderSection = (section, index, disabled) => {
    const canRemove = this.state.sections.length > 1;

    return (
      <div className="col-md-6" key={section.id}>
        <div className="mb-3 border rounded p-3" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="fw-bold mb-0">Section {index + 1}</h6>
            {canRemove && (
              <button
                type="button"
                className="btn btn-sm btn-outline-danger"
                onClick={() => this._removeSection(section.id)}
                disabled={disabled}
                title="Remove Section"
              >
                <i className="bi bi-trash"></i>
              </button>
            )}
          </div>
          
          <label className="form-label">Section Label</label>
          <input
            type="text"
            className="form-control mb-2"
            value={section.label}
            onChange={(e) => this._handleSectionChange(section.id, 'label', e.target.value)}
            disabled={disabled}
            placeholder="A"
            maxLength="3"
          />
          
          <label className="form-label">Certification Text</label>
          <textarea
            className="form-control mb-2"
            value={section.text}
            onChange={(e) => this._handleSectionChange(section.id, 'text', e.target.value)}
            disabled={disabled}
            rows="3"
          />
          <TextStyler
            style={section.textStyle}
            onChange={(style) => this._handleSectionChange(section.id, 'textStyle', style)}
            previewText={section.text}
            disabled={disabled}
            showPreview={false}
          />

          <label className="form-label mt-3">Name</label>
          <input
            type="text"
            className="form-control mb-2"
            value={section.name}
            onChange={(e) => this._handleSectionChange(section.id, 'name', e.target.value)}
            disabled={disabled}
          />
          <TextStyler
            style={section.nameStyle}
            onChange={(style) => this._handleSectionChange(section.id, 'nameStyle', style)}
            previewText={section.name}
            disabled={disabled}
            showPreview={false}
          />

          <label className="form-label mt-3">Position</label>
          <input
            type="text"
            className="form-control mb-2"
            value={section.position}
            onChange={(e) => this._handleSectionChange(section.id, 'position', e.target.value)}
            disabled={disabled}
          />
          <TextStyler
            style={section.positionStyle}
            onChange={(style) => this._handleSectionChange(section.id, 'positionStyle', style)}
            previewText={section.position}
            disabled={disabled}
            showPreview={false}
          />
        </div>
      </div>
    );
  };

  renderSignatureBlock = (section, index) => {
    return (
      <div 
        className="col-md-6" 
        key={section.id}
        style={{ 
          paddingTop: "0",
          paddingRight: "12px",
          paddingBottom: "12px",
          paddingLeft: "0",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
          <span 
            style={{
              display: "inline-flex",
              alignItems: "center",
              backgroundColor: "#f8f9fa",
              border: "1px solid #dee2e6",
              padding: "4px 8px",
              marginRight: "8px",
              fontWeight: "bold",
              borderRadius: "4px",
              flexShrink: 0,
            }}
          >
            {section.label}.
          </span>
          <span
            style={{
              fontSize: `${section.textStyle.fontSize}px`,
              fontWeight: section.textStyle.bold ? "bold" : "normal",
              fontStyle: section.textStyle.italic ? "italic" : "normal",
              color: section.textStyle.color,
              flex: 1,
            }}
          >
            {section.text}
          </span>
        </div>
        
        <div>
          <div className="d-flex justify-content-between align-items-start" style={{ marginTop: "20px", paddingLeft: "20px" }}>
            <div style={{ flex: 1, marginRight: "20px" }}>
              <div style={{ borderBottom: "1px solid #000", marginBottom: "5px" }}></div>
              <div
                style={{
                  fontSize: `${section.nameStyle.fontSize}px`,
                  fontWeight: section.nameStyle.bold ? "bold" : "normal",
                  fontStyle: section.nameStyle.italic ? "italic" : "normal",
                  color: section.nameStyle.color,
                  marginBottom: "5px",
                  textAlign: "center",
                }}
              >
                {section.name}
              </div>
              <div
                style={{
                  fontSize: `${section.positionStyle.fontSize}px`,
                  fontWeight: section.positionStyle.bold ? "bold" : "normal",
                  fontStyle: section.positionStyle.italic ? "italic" : "normal",
                  color: section.positionStyle.color,
                  textAlign: "center",
                }}
              >
                {section.position}
              </div>
            </div>
            
            <div style={{ width: "200px" }}>
              <div style={{ borderBottom: "1px solid #000", marginBottom: "5px" }}></div>
              <div style={{ fontSize: "12px", color: "#000", textAlign: "center" }}>Date</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { disabled, showInputs = true } = this.props;

    return (
      <div className="payroll-footer-container border rounded p-2">
        {showInputs && (
          <div className="mb-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Footer Configuration</h5>
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={this._addSection}
                disabled={disabled}
              >
                + Add Section
              </button>
            </div>
            <div className="row g-3">
              {this.state.sections.map((section, index) => 
                this.renderSection(section, index, disabled)
              )}
            </div>
          </div>
        )}

        {/* Footer Preview */}
        <div className="overflow-auto p-2">
          <div className="footer-preview bg-white border rounded" style={{ minWidth: "800px", maxWidth: "1000px", margin: "0 auto" }}>
            <div className="row g-0">
              {this.state.sections.map((section, index) => 
                this.renderSignatureBlock(section, index)
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PayrollFooter;
